import { combineEpics } from "redux-observable";
import history from "@ane/core/lib/CreateHistory";
import { provideAnalysisTemplateEpics } from "./views/AnalysisTemplate/epics/AnalysisTemplateEpics.js";
const analysisTemplateEpics = provideAnalysisTemplateEpics(history);
const rootEpic = combineEpics(analysisTemplateEpics);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
